import { render, staticRenderFns } from "./PageRow.vue?vue&type=template&id=1a6eca16&scoped=true&"
import script from "./PageRow.vue?vue&type=script&lang=ts&"
export * from "./PageRow.vue?vue&type=script&lang=ts&"
import style0 from "./PageRow.vue?vue&type=style&index=0&id=1a6eca16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6eca16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
